<template>
  <title>
    ProduceMart - The global online business to business market place for
    buying and selling wholesale agricultural produce and ingredients
  </title>
  <mainHeader />
  <!-- <searchHeader /> -->

  <!--Welcome Slider-->
  <section class="welcomeSlider">
    <div
      id="carouselExampleFade"
      class="carousel slide carousel-fade"
      data-bs-ride="carousel"
    >
      <div class="carousel-inner">
        <div class="carousel-item active" :style="sliderImage1">
          <div class="row justify-content-center">
            <div class="col-lg-8 text-center">
              <h1>No 1. Agriculture E-Commerce Platform</h1>
              <!-- <router-link to="/request-a-product"
                ><a>Request a product <i class="bi bi-arrow-right"></i></a
              ></router-link> -->
            </div>
          </div>
        </div>
        <div class="carousel-item" :style="sliderImage2">
          <div class="row justify-content-center">
            <div class="col-lg-8 text-center">
              <h1>
                A Reliable and Convenient Marketplace for Agricultural Products
              </h1>
              <!-- <router-link to="/request-a-product"
                ><a>Request a product <i class="bi bi-arrow-right"></i></a
              ></router-link> -->
            </div>
          </div>
        </div>
        <div class="carousel-item" :style="sliderImage3">
          <div class="row justify-content-center">
            <div class="col-lg-8 text-center">
              <h1>
                Making Sales and Purchase of Agricultural Products Digital
              </h1>
              <!-- <router-link to="/request-a-product"
                ><a>Request a product <i class="bi bi-arrow-right"></i></a
              ></router-link> -->
            </div>
          </div>
        </div>
      </div>
      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleFade"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleFade"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </section>
  <!--Welcome Slider Ends-->

  <!--Our Stats-->
  <section class="ourStats">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-9 text-center justify-content-between allStatBox">
          <div class="textHead">
            <p class="subhead">ProduceMart</p>
            <h2>Marketplace at a Glance</h2>
          </div>
          <div class="statBox">
            <div class="iconArea">
              <img
                style="padding-bottom: 10px !important"
                src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426635/ProducemartImages/icon-product_y93n1x.png"
                draggable="false" />
            </div>
            <div class="contentArea">
              <h5>Active Products</h5>
              <p>{{ prodSold }}
                <!-- <span>+</span> -->
              </p>
            </div>
            <div class="clear"></div>
          </div>

          <div class="statBox">
            <div class="iconArea">
              <img
                src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426662/ProducemartImages/icon-buyer_j6s7jv.png"
                draggable="false" />
            </div>
            <div class="contentArea">
              <h5>Registered Buyers</h5>
              <p>{{ buyer }}
                <!-- <span>+</span> -->
              </p>
            </div>
            <div class="clear"></div>
          </div>

          <div class="statBox">
            <div class="iconArea">
              <img
                src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426681/ProducemartImages/icon-supplier_ubpvdk.png"
                draggable="false" />
            </div>
            <div class="contentArea">
              <h5>Registered Suppliers</h5>
              <p>{{ supplier }}
                <!-- <span>+</span> -->
              </p>
            </div>
            <div class="clear"></div>
          </div>

          <!-- <div class="statBox">
            <div class="iconArea">
              <img src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426683/ProducemartImages/icon-quote_qieglj.png" draggable="false" />
            </div>
            <div class="contentArea">
              <h5>Quote Requests</h5>
              <p>{{quoteReq}}<span>+</span></p>
            </div>
            <div class="clear"></div>
          </div> -->
        </div>
      </div>
    </div>
  </section>
  <!--Our Stats Ends-->


  <!--Beta Testers-->
  <!-- <div class="row mt-4">
          <div
            class="alert alert-success text-center"
            style="width:70%; margin-left:auto; margin-right:auto; display:inline-flex; justify-content:center; font-size: 1.8rem; font-weight: 500; padding: 0.5rem 1rem; border-radius: 0.5rem;"
        >
           <p>
            Please <a href="https://usertest.producemart.com/" target="_blank" style="text-decoration: none; color: #53a85a; border-bottom: 5px solid #53a85a;
    padding-bottom: 1px;"> Click Here </a> to register now & participate in our exclusive Private User Test.
           </p>
        </div>
    </div> -->
  <!--End-->

  <!--About Section-->
  <section class="aboutSect">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="textArea">
            <div class="headText">
              <div class="iconHead">
                <img src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426723/ProducemartImages/main-logo_n8mzfz.png" draggable="false" />
              </div>
              <div class="textHead">
                <p class="subhead">ProduceMart</p>
                <h2>Who is ProduceMart?</h2>
              </div>
              <div class="clear"></div>
            </div>
            <div class="bodyText">
              <p class="content" style="text-align:justify">
                <a href="https://www.producemart.com/">Producemart.com</a> is an online B2B marketplace for wholesale agricultural produce and ingredients. Producemart makes it simpler than ever to list and source produce at a local, regional or international level. Acting as a platform for both suppliers and buyers, Producemart.com allows more efficient connections and assists with overcoming challenges such as language barriers, potential security concerns around engaging with new buyers and suppliers and cross-border purchases.
              </p>
              <router-link to="/about" class="route-link"
                ><a class="learnMore"
                  >Learn More <i class="bi bi-arrow-right"></i></a
              ></router-link>
            </div>
          </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <div class="imgArea">
            <img src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426749/ProducemartImages/aboutImg_rydp1o.png" draggable="false" />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--About Section Ends-->

  <!--How It Works-->
  <section class="howItWork">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 text-center mb-5">
          <div class="textHead">
            <p class="subhead">ProduceMart</p>
            <h2>How It Works</h2>
            <p class="belowHead">
              ProduceMart offers a seamless, secure, and efficient platform for buying and selling Wholesale produce. The escrow system ensures payment security, while reliable shipping guarantees timely delivery and satisfaction.
            </p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-3 text-center">
          <div class="circleBox boxLineRight">
            <div class="number">1</div>
            <img src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426794/ProducemartImages/icon-howItWork1_hgm3ik.png" draggable="false" />
            <h2>Register</h2>
            <h4>Suppliers and buyers sign up at www.producemart.com.</h4>
          </div>
        </div>
        <div class="col-md-3 text-center">
          <div class="circleBox boxLineRight ">
            <div class="number">2</div>
            <img src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426813/ProducemartImages/icon-howItWork2_bwtlaf.png" draggable="false" />
            <h2>Upload and Explore</h2>
            <h4>Suppliers list their products on ProduceMart, and Buyers browse the catalog.</h4>
          </div>
        </div>

        <div class="col-md-3 text-center">
          <div class="circleBox  boxLineRight ">
            <div class="number">3</div>
            <img src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426856/ProducemartImages/icon-howItWork3_ylblde.png" draggable="false" />
            <h2>Request and Quote</h2>
            <h4>Buyers request quotes on desired products, and suppliers confirm availability.</h4>
          </div>
        </div>

        <div class="col-md-3 text-center">
          <div class="circleBox">
            <div class="number">4</div>
            <img src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426820/ProducemartImages/icon-howItWork4_yj6bgp.png" draggable="false" />
            <h2>Secure Commitment</h2>
            <h4>Buyers pay into escrow to confirm their commitment to the transaction.</h4>
          </div>
        </div>

      </div>
      <div class="row justify-content-center">

        <div class="col-md-3 text-center">
          <div class="circleBox boxLineRight">
            <div class="number">5</div>
            <img
              src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426824/ProducemartImages/icon-howItWork5_e3hvyi.png"
              draggable="false" />
            <h2>Arrange Pickup</h2>
            <h4>The shipper schedules a pickup date and time with the supplier.</h4>
          </div>
        </div>

        <div class="col-md-3 text-center">
          <div class="circleBox boxLineRight">
            <div class="number">6</div>
            <img
              src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426813/ProducemartImages/icon-howItWork2_bwtlaf.png"
              draggable="false" />
            <h2>Delivery Inspection</h2>
            <h4>The order is delivered to the Buyer, who inspects the products to ensure they meet requirements.</h4>
          </div>
        </div>

        <div class="col-md-3 text-center">
          <div class="circleBox boxLineRight">
            <div class="number">7</div>
            <img
              src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426820/ProducemartImages/icon-howItWork4_yj6bgp.png"
              draggable="false" />
            <h2>Confirmation and Payment</h2>
            <h4>Once the Buyer accepts the order, they have 2 hours to confirm receipt to ProduceMart.</h4>
          </div>
        </div>

        <div class="col-md-3 text-center">
          <div class="circleBox">
            <div class="number">8</div>
            <img
              src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426824/ProducemartImages/icon-howItWork5_e3hvyi.png"
              draggable="false" />
            <h2>Payment Release</h2>
            <h4>ProduceMart releases the payment from escrow to the supplier after receiving delivery confirmation.</h4>
          </div>
        </div>



      </div>
      <div class="row justify-content-center">


        <!-- <div class="col-md-3 text-center">
          <div class="circleBox">
            <div class="number">9</div>
            <img src="https://res.cloudinary.com/dtx792i8k/image/upload/v1668426794/ProducemartImages/icon-howItWork1_hgm3ik.png" draggable="false" />
            <h4>Order received by buyer</h4>
          </div>
        </div> -->
      </div>
    </div>
  </section>
  <!--How It Works Ends-->

   <!--Video Section-->
   <section class="videoSection">
    <div class="container">
      <div class="row justify-content-center">
        <!-- <div class="col-md-10 text-center mb-4">
          <div class="textHead">
            <p class="subhead">ProduceMart</p>
            <h2>explainer video</h2>
          </div>
        </div> -->
        <!-- <div class="col-lg-8 text-center">
          <video class="video" controls controlsList="nodownload">
            <source src="" type="video/mp4" />
          </video>
        </div>  -->
        <div class="exVideo col-lg-6 text-center video">
          <h2 class="mb-3">Buyer Explainer Video</h2>
          <p class="mb-3">As a buyer of wholesale agricultural produce, watch our explainer video to see just how simple and efficient it is to source agricultural products through our platform</p>
          <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/0ueUvd4vYcA?si=zf-jPYuX6Qujxr35" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
          <iframe width="560" height="315" src="https://www.youtube.com/embed/S2XtZjw7MNM?si=fbSy_mHL8kfsqBF5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

        </div>
        <div class="exVideo col-lg-6 text-center video">
          <h2 class="mb-3">Supplier Explainer Video</h2>
          <p class="mb-3">Selling wholesale agricultural produce is now simpler and safer with our premier B2B agricultural marketplace! Watch our explainer video to see how easy it is to become a supplier on our platform.</p>
          <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/htQakSJYqks?si=QhHXYP2ZV0ITEOBz" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
          <iframe width="560" height="315" src="https://www.youtube.com/embed/Btwl1l4FhS4?si=vcKI_8eZN8qZxl3y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

        </div>
      </div>
    </div>
  </section>

  <!--Our Products-->
  <!-- <section class="ourProduct">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 text-center mb-4">
          <div class="textHead">
            <p class="subhead">ProduceMart</p>
            <h2>Our Products</h2>
          </div>
        </div>
        <div class="cat col-md-12">
          <ul
            class="nav nav-pills mb-5 justify-content-center"
            id="pills-tab"
            role="tablist"
          >
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active tabs-button"
                id="pills-allProducts-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-allProducts"
                type="button"
                role="tab"
                aria-controls="pills-allProducts"
                aria-selected="true"
              >
                All Products
              </button>
            </li>
            <li class="nav-item" role="presentation" v-if="firstProductCategory">
              <button
                class="nav-link tabs-button"
                id="pills-oil-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-oil"
                type="button"
                role="tab"
                aria-controls="pills-oil"
                aria-selected="false"
              >
                Oil
              </button>
            </li>
            <li class="nav-item" role="presentation" v-if="secondProductCategory">
              <button
                class="nav-link tabs-button"
                id="pills-fruits-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-fruits"
                type="button"
                role="tab"
                aria-controls="pills-fruits"
                aria-selected="false"
              >
                Fruits
              </button>
            </li>
            <li class="nav-item" role="presentation" v-if="thirdProductCategory">
              <button
                class="nav-link tabs-button"
                id="pills-vegetable-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-vegetable"
                type="button"
                role="tab"
                aria-controls="pills-vegetable"
                aria-selected="false"
              >
                Vegetable
              </button>
            </li>
          </ul>
          <div class="tab-content mt-2" id="pills-tabContent">

            <div
              class="tab-pane fade show active"
              id="pills-allProducts"
              role="tabpanel"
              aria-labelledby="pills-allProducts-tab"
            >
              <div class="container contProduct" v-if="products?.length > 0">
                <div class="row">
                  <div
                    class="itemProduct"
                    v-for="(product, i) in products"
                    :key="i"
                  >
                    <router-link :to="'/products/inner-product/' + product._id">
                      <div class="imgArea">
                        <img :src="product.img_url[0]" draggable="false" />
                      </div>
                    </router-link>
                    <div class="detailArea">
                      <h5 style="text-transform:capitalize">{{ product.name }}</h5>
                      <p>
                        {{currencyChanger(product.package.currency)}}{{ product.package.price }} per
                        {{ product.package.weight_unit }}
                      </p>
                      <router-link
                        :to="'/products/inner-product/' + product._id"
                        class="route-link"
                        ><a>View Product <i class="bi bi-arrow-right"></i></a
                      ></router-link>
                    </div>
                  </div>

                  <div class="col-lg-12 text-right viewMoreDiv">
                    <router-link to="/products" class="route-link"
                      ><a>View More</a></router-link
                    >
                  </div>
                </div>
              </div>
              <div class="container contProd" v-else>
                <p style="text-align: center">There's no product in this category.</p>
              </div>
            </div>

            <div
              class="tab-pane fade"
              id="pills-oil"
              role="tabpanel"
              aria-labelledby="pills-oil-tab"
            >
              <div class="container contProduct" v-if="firstProductCategory.length > 0">
                <div class="row">
                  <div
                    class="itemProduct"
                    v-for="(product, i) in firstProductCategory"
                    :key="i"
                  >
                    <router-link :to="'/products/inner-product/' + product._id">
                      <div class="imgArea">
                        <img :src="product.img_url[0]" draggable="false" />
                      </div>
                    </router-link>
                    <div class="detailArea">
                      <h5 style="text-transform:capitalize">{{ product.name }}</h5>
                      <p>
                        {{currencyChanger(product.package.currency)}}{{ product.package.price }} per
                        {{ product.package.weight_unit }}
                      </p>
                      <router-link
                        :to="'/products/inner-product/' + product._id"
                        class="route-link"
                        ><a>View Product <i class="bi bi-arrow-right"></i></a
                      ></router-link>
                    </div>
                  </div>

                  <div class="col-lg-12 text-right viewMoreDiv">
                    <router-link to="/products" class="route-link"
                      ><a>View More</a></router-link
                    >
                  </div>
                </div>
              </div>
              <div class="container contProd" v-else>
                <p style="text-align: center">There's no product in this category.</p>
              </div>
            </div>

            <div
              class="tab-pane fade"
              id="pills-fruits"
              role="tabpanel"
              aria-labelledby="pills-fruits-tab"
            >
              <div class="container contProduct" v-if="secondProductCategory.length > 0">
                <div class="row">
                  <div
                    class="itemProduct"
                    v-for="(product, i) in secondProductCategory"
                    :key="i"
                  >
                    <router-link :to="'/products/inner-product/' + product._id">
                      <div class="imgArea">
                        <img :src="product.img_url[0]" draggable="false" />
                      </div>
                    </router-link>
                    <div class="detailArea">
                      <h5 style="text-transform:capitalize">{{ product.name }}</h5>
                      <p>
                        {{currencyChanger(product.package.currency)}}{{ product.package.price }} per
                        {{ product.package.weight_unit }}
                      </p>
                      <router-link
                        :to="'/products/inner-product/' + product._id"
                        class="route-link"
                        ><a>View Product <i class="bi bi-arrow-right"></i></a
                      ></router-link>
                    </div>
                  </div>

                  <div class="col-lg-12 text-right viewMoreDiv">
                    <router-link to="/products" class="route-link"
                      ><a>View More</a></router-link
                    >
                  </div>
                </div>
              </div>
              <div class="container contProd" v-else>
                <p style="text-align: center">There's no product in this category.</p>
              </div>
            </div>

            <div
              class="tab-pane fade"
              id="pills-vegetable"
              role="tabpanel"
              aria-labelledby="pills-vegetable-tab"
            >
              <div class="container contProduct" v-if="thirdProductCategory.length > 0">
                <div class="row">
                  <div
                    class="itemProduct"
                    v-for="(product, i) in thirdProductCategory"
                    :key="i"
                  >
                    <router-link :to="'/products/inner-product/' + product._id">
                      <div class="imgArea">
                        <img :src="product.img_url[0]" draggable="false" />
                      </div>
                    </router-link>
                    <div class="detailArea">
                      <h5 style="text-transform:capitalize">{{ product.name }}</h5>
                      <p>
                        {{currencyChanger(product.package.currency)}}{{ product.package.price }} per
                        {{ product.package.weight
                      }}{{ product.package.weight_unit }}
                      </p>
                      <router-link
                        :to="'/products/inner-product/' + product._id"
                        class="route-link"
                        ><a>View Product <i class="bi bi-arrow-right"></i></a
                      ></router-link>
                    </div>
                  </div>

                  <div class="col-lg-12 text-right viewMoreDiv">
                    <router-link to="/products" class="route-link"
                      ><a>View More</a></router-link
                    >
                  </div>
                </div>
              </div>
              <div class="container contProd" v-else>
                <p style="text-align: center">There's no product in this category.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> -->
  <!--Our Products Ends-->

  <!--Video Section-->
  <!-- <section class="videoSection">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 text-center mb-4">
          <div class="textHead">
            <p class="subhead">ProduceMart</p>
            <h2>explainer video</h2>
          </div>
        </div>
        <div class="exVideo col-lg-6 text-center video">
          <h3>Buyer Explainer Video</h3>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/SCpdXPkxUaY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div class="exVideo col-lg-6 text-center video">
          <h3>Supplier Explainer Video</h3>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/tMlX2B_Un9w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </section> -->

  <!--Testimonial-->
  <!-- <section class="testimonial">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 text-center mb-4">
          <div class="textHead">
            <p class="subhead">Testimonials</p>
            <h2>Words From Our Clients</h2>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div
            id="carouselExampleIndicators"
            class="carousel slide testimonialSlider"
            data-bs-ride="carousel"
          >
            <div class="carousel-indicators">
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="0"
                class="active"
                aria-current="true"
                aria-label="Slide 1"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="1"
                aria-label="Slide 2"
              ></button>
            </div>
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div class="row justify-content-center testimonialDiv">
                  <div class="col-md-1">
                    <div class="testimonialImg">
                      <img
                        src="@/assets/img/testimonial1.png"
                        draggable="false"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="testimonialBox">
                      <div class="mainShape">
                        <img
                          class="quote"
                          src="@/assets/img/quote.png"
                          draggable="false"
                        />
                        <p>
                          “ProduceMart plays a very important role in the
                          agricultural sector and to my business personally. Im
                          glad to be one of the beneficiaries of this. Purchase
                          and sales have been made very easy and smooth ”
                        </p>
                        <h5>Chukka Uzo</h5>
                        <span>Exporter</span>
                      </div>
                      <div class="shape1"></div>
                      <div class="shape2"></div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="carousel-item">
                <div class="row justify-content-center testimonialDiv">
                  <div class="col-md-1">
                    <div class="testimonialImg">
                      <img
                        src="@/assets/img/testimonial1.png"
                        draggable="false"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="testimonialBox">
                      <div class="mainShape">
                        <img
                          class="quote"
                          src="@/assets/img/quote.png"
                          draggable="false"
                        />
                        <p>
                          “ProduceMart plays a very important role in the
                          agricultural sector and to my business personally. Im
                          glad to be one of the beneficiaries of this. Purchase
                          and sales have been made very easy and smooth ”
                        </p>
                        <h5>Chukka Uzo</h5>
                        <span>Exporter</span>
                      </div>
                      <div class="shape1"></div>
                      <div class="shape2"></div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <i class="bi bi-arrow-left"></i>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              <i class="bi bi-arrow-right"></i>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section> -->
  <!--Testimonial Ends-->
  <!-- <contact-button></contact-button> -->
  <!-- <subscribeNewsletter/> -->

  <!-- <subscribe-newsletter /> -->
  <main-footer />

  <!-- <mainFooter /> -->
</template>
<style scoped src="@/assets/css/styleFrontend.css"></style>
<style scoped src="@/assets/css/bootstrap.css"></style>
<style scoped>
  .exVideo{
    margin: 15px 5px 15px 5px
  }
  .exVideo iframe{
    border: 8px solid #97F29F;
    border-radius: 20px;
    width: 500px;
  }
  @media screen and (max-width: 991px) {
    .exVideo iframe{
      width: 400px;
    }
  }

  .cat .nav{
    background: #fff;
  }

</style>
<script>
import MainHeader from "./mainHeader.vue";
import SearchHeader from "./searchHeader.vue";
import SubscribeNewsletter from "./subscribeNewsletter.vue";
import MainFooter from "./mainFooter.vue";
import SearchInner from "./searchInner.vue";
import { API } from "@/util/APIroute";
import { ToastAlert } from '@/util/SweetAlertUtl';
import {currencyChanger} from "@/util/index"
export default {
  name: "ProduceMart",
  components: {
    mainHeader: MainHeader,
    searchHeader: SearchHeader,
    subscribeNewsletter: SubscribeNewsletter,
    mainFooter: MainFooter,
    searchInner: SearchInner,

    // contactButton
  },
  data() {
    return {
      currencyChanger: currencyChanger,
      sliderImage1: {
        backgroundImage: `url(https://res.cloudinary.com/dtx792i8k/image/upload/v1668431379/ProducemartImages/sliderImg1_gkpcjc.jpg)`,
      },
      sliderImage2: {
        backgroundImage: `url(https://res.cloudinary.com/dtx792i8k/image/upload/v1668431380/ProducemartImages/sliderImg2_ltwcke.jpg)`,
      },
      sliderImage3: {
        backgroundImage: `url(https://res.cloudinary.com/dtx792i8k/image/upload/v1668431381/ProducemartImages/sliderImg3_lpgsf8.jpg)`,
      },
      products: [],
      firstProductCategory: [],
      secondProductCategory: [],
      thirdProductCategory: [],
      categories: [],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    // this.getAllproducts();

  },
  methods: {
    async getAllproducts() {
      const res = await fetch(
        `${API}/getAllProducts`
      );
      const { data,message, status } = await res.json();
        if(!status){
          return ToastAlert(message, "error")
        }
        const exProd = data.filter((val) => val.status == "active");
      this.products = exProd.splice(0, 8)
      exProd.map((prod) => {
        if (prod.category != this.categories[this.categories.length])
          this.categories.push(prod.category);
      });

      this.firstProductCategory = this.products.filter(
        (prd) => prd.category == 'oil'
      ).splice(0, 8);
      //console.log(this.firstProductCategory);
      this.secondProductCategory = this.products.filter(
        (prd) => prd.category == 'fruit'
      ).splice(0, 8);
      //console.log(this.secondProductCategory);
      this.thirdProductCategory = this.products.filter(
        (prd) => prd.category == 'vegetable'
      ).splice(0, 8);
      //console.log(this.thirdProductCategory);
      //console.log(this.products);

      // this.products = data;
      // console.log(this.products);
    },
  },
};
</script>
<script setup>
import {ref, reactive, onMounted, computed} from 'vue'
import {useHead} from '@vueuse/head';

        const siteData = reactive({
            title: `ProduceMart`,
            description: `Producemart.com is a brand new online B2B marketplace for wholesale agricultural produce and ingredients. It aims to make it simpler than ever to list and source produce at a local, regional or international level. Acting as an intermediary platform for both suppliers and buyers, producemart.com allows them to connect more efficiently, overcoming challenges such as language barriers or potential security concerns around engaging with new buyers and suppliers and cross-border purchases.`
        })

useHead({
    title: computed(() => siteData.title),
    description: computed(() => siteData.description),
    meta:[
      {
        name: "title",
        content: `ProduceMart`
        },
      {
        name: "description",
        content: "Producemart.com is a brand new online B2B marketplace for wholesale agricultural produce and ingredients. It aims to make it simpler than ever to list and source produce at a local, regional or international level. Acting as an intermediary platform for both suppliers and buyers, producemart.com allows them to connect more efficiently, overcoming challenges such as language barriers or potential security concerns around engaging with new buyers and suppliers and cross-border purchases."
      },
        {
        property: "og:title",
        content: `ProduceMart`
        },
        {
        property: "og:site_name",
        content: "ProduceMart"
        },
        {
          property: "og:description",
          content: "Producemart.com is a brand new online B2B marketplace for wholesale agricultural produce and ingredients. It aims to make it simpler than ever to list and source produce at a local, regional or international level. Acting as an intermediary platform for both suppliers and buyers, producemart.com allows them to connect more efficiently, overcoming challenges such as language barriers or potential security concerns around engaging with new buyers and suppliers and cross-border purchases."
        },
        {
        property: "og:url",
        content: `/`
        },
        {
        property: "og:type",
        content: "website"
        },
        {
        property: "og:image",
        itemProp: "image",
        content: `/logo.png`
        },
        {
        property: "og:locale",
        content: "en:GB"
        },
        {
        property: "og:image:width",
        content: "1200"
        },
        {
        property: "og:image:height",
        content: "600"
        },
        {
        name: "twitter:card",
        content: "summary_large_image"
        },
        {
        name: "twitter:image:alt",
        content: `ProduceMart`
        },
        {
        name: "twitter:title",
        content: `ProduceMart`
        },
        {
        name: "twitter:description",
        content: "Producemart.com is a brand new online B2B marketplace for wholesale agricultural produce and ingredients. It aims to make it simpler than ever to list and source produce at a local, regional or international level. Acting as an intermediary platform for both suppliers and buyers, producemart.com allows them to connect more efficiently, overcoming challenges such as language barriers or potential security concerns around engaging with new buyers and suppliers and cross-border purchases."
        },
        {
        name: "twitter:image",
        content: `/logo.png`
        }
      ]
  })

  let counts = ref('')
const DashboardCounts = async () => {
  const res = await fetch(`${API}/countDashboard`)

  const data = await res.json()
  if (!data.status) {
    return ToastAlert(data.message, "error")
  }
  counts.value = data.data
  //  console.log(counts.value)
}

onMounted(() => {
  DashboardCounts()
})

let prodSold = ref(0)
let buyer = ref(0)
let supplier = ref(0)
let quoteReq = ref(0)

const prod = setInterval(() => {
  project1_work()
}, 100)
const buy = setInterval(() => {
  project2_work()
}, 100)
const sup = setInterval(() => {
  project3_work()
}, 100)
// const qup = setInterval(() => {
//   project4_work()
// }, 100)



function m(n, d) {
  let x = ('' + n).length, p = Math.pow;
  d = p(10, d)
  x -= x % 3
  return Math.round(n * d / p(10, x)) / d + " kMGTPE"[x / 3]
}


const project1_work = () => {
  if (counts.value) {
    if (counts.value.activeProduct === 0) {
      clearInterval(prod)
      prodSold.value = counts.value.activeProduct
    } else if (counts.value.activeProduct <=10) {
      prodSold.value++
      if (prodSold.value === counts.value.activeProduct) {
        clearInterval(prod)
        prodSold.value = counts.value.activeProduct
      }
    } else {
      prodSold.value++
      if(prodSold.value == 10){
        clearInterval(prod)
        if (counts.value.activeProduct >= 1000) {
        prodSold.value = m(counts.value.activeProduct, 1)
        }else{
          prodSold.value = counts.value.activeProduct
        }
      }

    }


  }

}

const project2_work = () => {
  if (counts.value) {
    if (counts.value.activeBuyer === 0) {
      clearInterval(buy)
      buyer.value = counts.value.activeBuyer
    } else if (counts.value.activeBuyer <= 10) {
      buyer.value++
      if (buyer.value == counts.value.activeBuyer) {
        clearInterval(buy)
        buyer.value = counts.value.activeBuyer
      }
    } else {
      buyer.value++
      if(buyer.value == 10){
        clearInterval(buy)
        if (counts.value.activeBuyer >= 1000) {
        buyer.value = m(counts.value.activeBuyer, 1)
      }else{
        buyer.value = counts.value.activeBuyer
      }
      }

    }

  }
}
const project3_work = () => {
  if (counts.value) {
    if (counts.value.activeSupplier === 0) {
      clearInterval(sup)
      supplier.value = counts.value.activeSupplier
    } else if (counts.value.activeSupplier <= 10) {
      supplier.value++
      if (supplier.value === counts.value.activeSupplier) {
        clearInterval(sup)
        supplier.value = counts.value.activeSupplier
      }
    } else {
      supplier.value++
      if (supplier.value == 10) {
        clearInterval(sup)
        if(counts.value.activeSupplier >= 1000){
          supplier.value = m(counts.value.activeSupplier, 1)
        }else{
          supplier.value = counts.value.activeSupplier
        }
      }
    }

  }
}

// const project4_work = () => {
//   if (counts.value) {
//     if (counts.value.quotes === 0) {
//       clearInterval(qup)
//       quoteReq.value = counts.value.quotes
//     } else {
//       quoteReq.value++
//       if (quoteReq.value === counts.value.quotes) {
//         clearInterval(qup)
//         quoteReq.value = counts.value.quotes
//       }
//     }

//   }
// }


</script>
